export default "__VITE_ASSET__CMv7srbr__"